function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

export { getMainAxisFromPlacement as g };
//# sourceMappingURL=getMainAxisFromPlacement-COBB0n5w.js.map
